import {
  PluginShopCurrencySchema_2023_08_20,
  PluginShopCurrencyType_2023_08_20,
} from "./2023-08-20";

export const PluginShopCurrencySchema = PluginShopCurrencySchema_2023_08_20;
export type PluginShopCurrencyType = PluginShopCurrencyType_2023_08_20;
